import orders from './orders';

export default {
  orders,
};
